<template>
  <div class="campaigns-bg">
    <section>
      <h1>Campanhas em destaque</h1>
      <b-row class="campaigns-wrapper">
        <CampaignCard
          v-for="campaign in activeAdvertisers.slice(0,4)"
          :campaign="campaign"
          :key="campaign.code"
        />
      </b-row>
    </section>
    <section>
      <h1>Outras campanhas</h1>
      <b-row class="campaigns-wrapper">
        <CampaignCard
          v-for="campaign in activeAdvertisers.slice(4)"
          :campaign="campaign"
          :key="campaign.code"
        />
      </b-row>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CampaignCard from '@/components/CampaignCard';

export default {
  name: 'Campaigns',
  components: {
    CampaignCard,
  },
  async created() {
    await this.fetchAdvertisers();
  },
  computed: {
    ...mapGetters(['activeAdvertisers']),
  },
  methods: {
    ...mapActions(['fetchAdvertisers']),
  },
};
</script>

<style lang="scss" scoped>
  h1 {
    font: 21px $font-1;
    font-weight: 100;
    color: #88765A;
    margin: 0;
    padding-top: 60px;
    padding-bottom: 20px;
  }

  @media (max-width: 767px) {
    h1 {
      padding-top: 20px;
      padding-bottom: 10px;
      font-weight: 400;
      font-size: 23px;
    }
  }

  section {
    margin: 0 auto;
    @media (max-width: 575px) { padding: 0 15px; }
    @media (min-width: 576px) { max-width: 540px; }
    @media (min-width: 768px) { max-width: 720px; }
    @media (min-width: 992px) { max-width: 960px; }
    @media (min-width: 1200px) { max-width: 1140px; }
  }

  .campaigns-bg {
    background: $bg-gray;
    max-width: auto;
    padding-bottom: 70px;
  }

  .campaigns-wrapper {
    padding: 0 15px;
  }
</style>
